import { render, staticRenderFns } from "./UpdateRequestModal.vue?vue&type=template&id=1178e49b&"
import script from "./UpdateRequestModal.vue?vue&type=script&lang=js&"
export * from "./UpdateRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRequestModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports